
export interface LanguageOption {
  readonly code: string;
  readonly label: string;
}

export const LANGUAGES: readonly LanguageOption[] = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'Английский' },
  { code: 'pt-BR', label: 'Португальский (Бразилия)' },
  { code: 'hi', label: 'Хинди' },

  { code: 'az', label: 'Азербайджанский' },
  { code: 'ar', label: 'Арабский' },
  { code: 'hy', label: 'Армянский' },
  { code: 'af', label: 'Африкаанс' },
  { code: 'be', label: 'Белорусский' },
  { code: 'bn', label: 'Бенгальский' },
  { code: 'bg', label: 'Болгарский' },
  { code: 'bs', label: 'Боснийский' },
  { code: 'cy', label: 'Валлийский' },
  { code: 'hu', label: 'Венгерский' },
  { code: 'vi', label: 'Вьетнамский' },
  { code: 'gl', label: 'Галисийский' },
  { code: 'el', label: 'Греческий' },
  { code: 'ka', label: 'Грузинский' },
  { code: 'gu', label: 'Гуджарати' },
  { code: 'da', label: 'Датский' },
  { code: 'he', label: 'Иврит' },
  { code: 'id', label: 'Индонезийский' },
  { code: 'ga', label: 'Ирландский' },
  { code: 'is', label: 'Исландский' },
  { code: 'es', label: 'Испанский' },
  { code: 'it', label: 'Итальянский' },
  { code: 'kk', label: 'Казахский' },
  { code: 'kn', label: 'Каннада' },
  { code: 'ca', label: 'Каталанский' },
  { code: 'zh', label: 'Китайский' },
  { code: 'ko', label: 'Корейский' },
  { code: 'lv', label: 'Латышский' },
  { code: 'lt', label: 'Литовский' },
  { code: 'mk', label: 'Македонский' },
  { code: 'ms', label: 'Малайский' },
  { code: 'ml', label: 'Малаялам' },
  { code: 'mr', label: 'Маратхи' },
  { code: 'de', label: 'Немецкий' },
  { code: 'ne', label: 'Непальский' },
  { code: 'nl', label: 'Нидерландский' },
  { code: 'no', label: 'Норвежский' },
  { code: 'pa', label: 'Панджаби' },
  { code: 'fa', label: 'Персидский' },
  { code: 'pl', label: 'Польский' },
  { code: 'pt', label: 'Португальский (Португалия)' },
  { code: 'ro', label: 'Румынский' },
  { code: 'sr', label: 'Сербский' },
  { code: 'sk', label: 'Словацкий' },
  { code: 'sl', label: 'Словенский' },
  { code: 'sw', label: 'Суахили' },
  { code: 'ta', label: 'Тамильский' },
  { code: 'th', label: 'Тайский' },
  { code: 'te', label: 'Телугу' },
  { code: 'tr', label: 'Турецкий' },
  { code: 'uz', label: 'Узбекский' },
  { code: 'uk', label: 'Украинский' },
  { code: 'ur', label: 'Урду' },
  { code: 'fil', label: 'Филиппинский' },
  { code: 'fi', label: 'Финский' },
  { code: 'fr', label: 'Французский' },
  { code: 'hr', label: 'Хорватский' },
  { code: 'cs', label: 'Чешский' },
  { code: 'sv', label: 'Шведский' },
  { code: 'et', label: 'Эстонский' },
  { code: 'ja', label: 'Японский' },
];

const BY_CODE = new Map(LANGUAGES.map((item) => [item.code.toLowerCase(), item.label]));

export function languageLabel(code: string | null | undefined): string {
  if (!code) return '';
  return BY_CODE.get(code.toLowerCase()) ?? code;
}

const TUNABLE_MODEL_CODES = new Set([
  'ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'fi', 'fil', 'fr', 'hi', 'hr', 'id',
  'it', 'ja', 'ko', 'ms', 'nl', 'pl', 'pt', 'ro', 'ru', 'sk', 'sv', 'ta', 'tr', 'uk', 'zh',
]);

const CARTESIA_CODES = new Set(['ru', 'en', 'bg', 'pt', 'hi', 'es', 'de', 'fr', 'tr', 'pl']);

function narrow(codes: Set<string>): readonly LanguageOption[] {
  return LANGUAGES.filter((item) => codes.has((item.code.split('-')[0] ?? '').toLowerCase()));
}

export function languagesForModel(model: string): readonly LanguageOption[] {
  if (model === 'sonic-3') return narrow(CARTESIA_CODES);
  if (model === 'eleven_multilingual_v2') return narrow(TUNABLE_MODEL_CODES);
  return LANGUAGES;
}

export function modelSupportsLanguage(model: string, code: string): boolean {
  return languagesForModel(model).some((item) => item.code === code);
}
